// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tungstyle input[type=\"text\"]\n{\n  border: none ;\n  width: \"auto\";\n}", "",{"version":3,"sources":["webpack://./src/components/ReportDetail/textbox.css"],"names":[],"mappings":"AAAA;;EAEE,aAAa;EACb,aAAa;AACf","sourcesContent":[".tungstyle input[type=\"text\"]\n{\n  border: none ;\n  width: \"auto\";\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
